<template>
    <div>
        <div v-if="projects.length > 0" class="grid grid-cols-1 col-gap-6 row-gap-8">
            <project-card v-for="project in projects" :key="project.id" :project="project" />
        </div>
        <div v-else class="text-gray-600 font-hairline">
            No posted job found for this employer.
        </div>
    </div>
</template>

<script>
export default {
    props: {
        employerId: {
            type: [String, Number],
            required: true
        }
    },

    data() {
        return {
            projects: []
        };
    },

    mounted() {
        this.fetchProjects();
    },

    methods: {
        fetchProjects() {
            axios.get(`/api/employers/${this.employerId}/projects`).then(response => {
                this.projects = response.data.data;
            });
        }
    }
};
</script>
